import { filter } from 'ramda';
import React from 'react';
import { node } from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import Title from './title';
import Icon from '../../icon';
import List, { ListItem, ListDetail } from '../../list';

const messages = defineMessages({
  possibleReasons: {
    id: 'mdc.wrappers.possibleReasons',
    defaultMessage: 'Possible reasons:',
  },
});

const EmptyMessage = ({ title, reasons }) => (
  <div className="empty-message">
    {title && <Title title={title} />}
    {reasons && (
      <List className="empty-message-reasons" dense>
        <h3 className="mdc-list-group__subheader">
          <FormattedMessage {...messages.possibleReasons} />
        </h3>
        {React.Children.map(filter(Boolean, reasons), reason => (
          <ListItem>
            <ListDetail start>
              <Icon className="reason-icon">radio_button_unchecked</Icon>
            </ListDetail>
            {reason}
          </ListItem>
        ))}
      </List>
    )}
  </div>
);

EmptyMessage.propTypes = {
  title: node,
  reasons: node.isRequired,
};

EmptyMessage.defaultProps = {
  title: undefined,
};

export default EmptyMessage;
